import PropTypes from "prop-types"
import { useEffect, useContext } from "react"
import { useParams } from "react-router-dom"

import GenericNotFound from "app/generic-not-found"
import { Breadcrumbs } from "areas/helpdesk/index"
import Loading from "areas/helpdesk/loading"
import { HelpdeskContext, fetchCollection } from "contexts/helpdesk"

/**
 * High Order Component for fetching helpdesk collection results
 * @param {React Component} WrappedComponent
 */
const fetchCollectionData = (WrappedComponent) => (props) => {
  const { state, dispatch } = useContext(HelpdeskContext)
  const InternalFetchCollection = ({
    collections,
    fetchCollection,
    helpdeskArticle,
    helpdeskCollection,
    staticContext,
    ...props
  }) => {
    const { collection_id, category_id } = useParams()

    // Determine initial values to display
    let initialValues
    if (helpdeskCollection) {
      initialValues =
        Object.entries(collections).length > 0
          ? collections
          : helpdeskCollection.data
    } else {
      initialValues = {}
    }

    let results = initialValues
    // Handle SPA behaviour of navigating to collections

    useEffect(() => {
      fetchCollection(collection_id, category_id)
    }, [collection_id, category_id])

    // Handle SPA/Regular Link behaviour of navigating to different collections
    // depending on the collection changing/updating
    if (Object.keys(collections || {}).length > 0) {
      results = collections
    } else if (helpdeskCollection) {
      results = helpdeskCollection.data
    } else {
      results = {}
    }

    if (!helpdeskCollection && !results) {
      return <Loading />
    }
    if (
      helpdeskCollection?.errors ||
      results?.errors ||
      helpdeskArticle?.errors
    )
      return <GenericNotFound staticContext={staticContext} />

    return (
      <Breadcrumbs
        helpdeskArticle={helpdeskArticle}
        helpdeskCollection={helpdeskCollection}
        results={results}
        {...props}
      >
        <WrappedComponent
          {...props}
          helpdeskArticle={helpdeskArticle}
          results={results}
          staticContext={staticContext}
        />
      </Breadcrumbs>
    )
  }

  InternalFetchCollection.propTypes = {
    collections: PropTypes.object,
    fetchCollection: PropTypes.func,
    helpdeskArticle: PropTypes.object,
    helpdeskCollection: PropTypes.object,
    staticContext: PropTypes.object,
  }

  const mapStateToProps = {
    collections: state.collections,
  }

  const mapDispatchToProps = {
    fetchCollection: (collectionId = "", categoryId = "") => {
      fetchCollection(collectionId, dispatch, categoryId)
    },
  }

  const combineProps = {
    ...props,
    ...mapStateToProps,
    ...mapDispatchToProps,
  }

  return InternalFetchCollection(combineProps)
}

export default fetchCollectionData
